export const enum ModalTypes {
	ADD_NEW_USER_MODAL = 'ADD_NEW_USER_MODAL',
	ADD_NEW_CLIENT_MODAL = 'ADD_NEW_CLIENT_MODAL',
	ADD_NEW_PRODUCT_MODAL = 'ADD_NEW_PRODUCT_MODAL',
	ADD_NEW_LICENSE_MODAL = 'ADD_NEW_LICENSE_MODAL',
	ADD_NEW_APPLICATION_MODAL = 'ADD_NEW_APPLICATION_MODAL',
	DEACTIVATE_USER = 'DEACTIVATE_USER',
	DEACTIVATE_APP = 'DEACTIVATE_APP',
	DEACTIVATE_LICENSE = 'DEACTIVATE_LICENSE',
	DEACTIVATE_INSTANCE = 'DEACTIVATE_INSTANCE',
	CHANGE_PRODUCT_STATUS = 'CHANGE_PRODUCT_STATUS',
	CHANGE_CLIENT_STATE = 'CHANGE_CLIENT_STATE',
	ACTIVATE_INSTANCE = 'ACTIVATE_INSTANCE',
	ACTIVATE_LICENSE = 'ACTIVATE_LICENSE',
	ACTIVATE_APP = 'ACTIVATE_APP',
	ACTIVATE_USER = 'ACTIVATE_USER',
	GET_PRODUCT_PUBLIC_KEY = 'GET_PRODUCT_PUBLIC_KEY',
	UPDATE_PRODUCT = 'UPDATE_PRODUCT',
	UPDATE_LICENSE = 'UPDATE_LICENSE',
	UPDATE_CLIENT = 'UPDATE_CLIENT',
	UPDATE_APP = 'UPDATE_APP',
	UPDATE_USER_OR_PROFILE = 'UPDATE_USER_OR_PROFILE',
	DELETE_CLIENT_COMMENT_MODAL = 'DELETE_CLIENT_COMMENT_MODAL',
	DELETE_INSTANCE = 'DELETE_INSTANCE',
	DELETE_PRODUCT_FUNCTIONALITY = 'DELETE_PRODUCT_FUNCTIONALITY',
	ADD_PRODUCT_FUNCTIONALITIES = 'ADD_PRODUCT_FUNCTIONALITIES',
	EDIT_PRODUCT_FUNCTIONALITIES = 'EDIT_PRODUCT_FUNCTIONALITIES',
	EDIT_INSTANCE_NAME_MODAL = 'EDIT_INSTANCE_NAME_MODAL',
	RENEW_INSTANCE_LICENSE_MODAL = 'RENEW_INSTANCE_LICENSE_MODAL',
	MT_INFO_MODAL = 'MT_INFO_MODAL',
	LICENSE_FILE_LINK_MODAL = 'LICENSE_FILE_LINK_MODAL',
	DISPLAY_SIMILAR_NAMES_MODAL = 'DISPLAY_SIMILAR_NAMES_MODAL',
	ADD_NEW_PRESET_MODAL = 'ADD_NEW_PRESET_MODAL',
	EDIT_PRESET_MODAL = 'EDIT_PRESET_MODAL',
	DELETE_PRESET_MODAL = 'DELETE_PRESET_MODAL',
	DELETE_APP_MODAL = 'DELETE_APP_MODAL',
	DELETE_CLIENT_MODAL = 'DELETE_CLIENT_MODAL',
	FUNCTIONALITY_VALUES_MODAL = 'FUNCTIONALITY_VALUES_MODAL',
	RESET_APPLICATION_SECRET_MODAL = 'RESET_APPLICATION_SECRET_MODAL',
	EDIT_NOTIFICATION_SUBSCRIBERS_MODAL = 'EDIT_NOTIFICATION_SUBSCRIBERS_MODAL',
	NEW_CLIENT_LABEL_MODAL = 'NEW_CLIENT_LABEL_MODAL',
	DELETE_CLIENT_LABEL_MODAL = 'DELETE_CLIENT_LABEL_MODAL',
	EDIT_CLIENT_LABEL_MODAL = 'EDIT_CLIENT_LABEL_MODAL',
	SHOW_409_MODAL = 'SHOW_409_MODAL',
}

export interface ModalSchema {
	modalType?: ModalTypes
	data?: any
}
